// Shared verbatim between frontend and backend (scripts/verifier-parite-regles.mjs): the app labels a
// device exactly as the API stores it in the account's device list (VOL-14).

export const DEVICE_NAME_MAX_LENGTH = 80;

/**
 * A cosmetic label must never block a sign-in: anything unusable becomes
 * `undefined` and a long name is cut instead of rejected.
 */
export function cleanDeviceName(value: unknown): string | undefined {
  if (typeof value !== 'string') return undefined;
  // eslint-disable-next-line no-control-regex
  const name = value.replace(/[\u0000-\u001f\u007f]/g, ' ').replace(/\s+/g, ' ').trim();
  return name ? name.slice(0, DEVICE_NAME_MAX_LENGTH).trim() : undefined;
}
